import { HFlow } from 'bold-ui'
import { HLabel } from 'components/HLabel'
import { OrigemAtendimento } from 'graphql/types.generated'
import React from 'react'
import { OrigemAtendimentoRecord } from 'types/enums'
import { humanizeAge } from 'util/date/humanize-age'
import { humanizeDate } from 'util/date/humanize-date'

interface HistoricoIdadeOrigemAtendimentoProps {
  dataNascimentoCidadao: LocalDate
  dataAtendimento: LocalDate
  origemAtendimento: OrigemAtendimento
}

export default function HistoricoIdadeOrigemAtendimento(props: HistoricoIdadeOrigemAtendimentoProps) {
  const { dataNascimentoCidadao, dataAtendimento, origemAtendimento } = props
  return (
    <HFlow hSpacing={0.25}>
      <HLabel title='Idade do atendimento:'>{humanizeDate(dataAtendimento)}</HLabel>|
      <HLabel title='Origem do atendimento:'>{OrigemAtendimentoRecord[origemAtendimento]}</HLabel>|
      <HLabel title='Idade do paciente no dia:'>{humanizeAge(dataNascimentoCidadao, dataAtendimento)}</HLabel>
    </HFlow>
  )
}
